export default "__VITE_ASSET__DEBU3o3y__"